import { stat } from "fs-extra";
import {
    RETURN_ORDERLIST_REQUEST,
    RETURN_ORDERLIST_SUCCESS,
    RETURN_ORDERLIST_FAILURE,
    RETURN_ORDER_FILTERLIST,
    RETURN_ORDER_PRODUCT,
    RETURN_ORDER_REASONREQUEST,
    RETURN_ORDER_REASONSUCCESS,
    RETURN_ORDER_REASONFAILURE,
    SAVE_RETURN_ORDER_REQUEST,
    SAVE_RETURN_ORDER_SUCCESS,
    SAVE_RETURN_ORDER_FAILURE,
    RETURNORDERINFO_CLEAR,
} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    returnOrderList: [],
    returnOrderFilterList : [],
    returnOrderReasonList : [],
    error: null,
};

export default function returnOrderListReducer(state = initialState, action) {
    // 
    switch (action.type) {
        case RETURN_ORDERLIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case RETURN_ORDERLIST_SUCCESS: 
            return {
                ...state,
                returnOrderList: action.data.order_list,
                loading: false,
            };
        case RETURN_ORDERLIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case RETURN_ORDER_FILTERLIST:
            return{
                ...state,
                returnOrderFilterList:action.data,
                loading: false,
            }
        case RETURN_ORDER_PRODUCT:
            return{
                ...state,
                returnOrderProduct:action.data,
                loading: false,
            }
        case RETURN_ORDER_REASONREQUEST:
            return {
                ...state,
                loading: true,
            };
        case RETURN_ORDER_REASONSUCCESS: 
            return {
                ...state,
                returnOrderReasonList: action.data.return_reason_list,
                loading: false,
            };
        case RETURN_ORDER_REASONFAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case SAVE_RETURN_ORDER_REQUEST:
            return {
                ...state,
                loading: true,
                successLoading: true,
            };
        case SAVE_RETURN_ORDER_SUCCESS:
            return {
                ...state,
                successLoading: false,
                loading: false,
                // always replacing data
                success: true,
                orderInfo: null,
            };
        case SAVE_RETURN_ORDER_FAILURE:
            return {
                ...state,
                successLoading: false,
                successError: action.error,
            };
        case RETURNORDERINFO_CLEAR:
            return{
                ...state,
                returnOrderList:[],
                returnOrderFilterList:[],
                returnOrderProduct:[],
                // returnOrderReasonList:[],
                orderInfo:null,
                loading:false,
                successLoading:false,
                success:false,
            }
        default:
            return state;
    }
}
